import { useRecordContext, useTranslate } from "ra-core";
import { isNaiuTenant } from "@/lib/tenant";
import type { Contact } from "../types";

const PRODUCT_LINES = [
  { value: "vital", label: "NAIU Vital" },
  { value: "fungi", label: "NAIU Fungi" },
  { value: "both", label: "Las dos" },
];

const HEALTH_GOALS = [
  { value: "energia", label: "Energía" },
  { value: "enfoque", label: "Enfoque" },
  { value: "inmune", label: "Sistema inmune" },
  { value: "rendimiento", label: "Rendimiento" },
  { value: "otro", label: "Otro" },
];

export function NaiuContactSummary() {
  const record = useRecordContext<Contact>();
  const translate = useTranslate();
  if (!isNaiuTenant() || !record) {
    return null;
  }

  const line =
    PRODUCT_LINES.find((item) => item.value === record.product_line)?.label ??
    record.product_line;
  const goal =
    HEALTH_GOALS.find((item) => item.value === record.health_goal)?.label ??
    record.health_goal;

  return (
    <div className="flex flex-col gap-1 text-sm">
      {line ? <p>{line}</p> : null}
      {record.products ? <p>{record.products}</p> : null}
      {goal ? <p>{goal}</p> : null}
      {record.last_purchase_date ? (
        <p>
          {translate("resources.contacts.fields.last_purchase_date", {
            _: "Última compra",
          })}
          : {record.last_purchase_date}
        </p>
      ) : null}
      {record.repurchase_days ? (
        <p>
          {translate("resources.contacts.fields.repurchase_days", {
            _: "Recompra cada (días)",
          })}
          : {record.repurchase_days}
        </p>
      ) : null}
    </div>
  );
}
